import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 60px;
  background-color: #d9485d;
  display: flex;
  align-items: center;
  padding: 0 2.5rem;
  justify-content: space-between;

  .imag {
    display: flex;
    align-items: center;
    img {
      width: 53px;
    }
  }

  .menu {
    width: 70vw;
    color: #ffffff;
    font-weight: 600;
    .link {
      margin-left: 40px;
      font-size: 1.25rem;
      &:hover {
        border-bottom: 1px solid #ffffff;
      }
      &:active{
        border-bottom: 1px solid #ffffff;
      }
    }
  }

  .sair-instagram{
    display: flex;
    align-items: center;
  }

  .menu-hamburguer {
    display: none;
  }

  .btn {
    display: flex;
    gap: 5px;
    width: 80px;
    height: 32px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border: 1px solid #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
    margin-left: 8px;
  }

  @media screen and (max-width: 920px) {
    .menu {
      .link {
        font-size: 1.2rem;
      }
    }
  }

  @media screen and (max-width: 880px) {
    .menu {
      .link {
        font-size: 1.1rem;
      }
    }
    .btn {
      width: 90px;
      font-size: 1.2rem;
      padding: 4px 5px;
    }
  }

  @media screen and (max-width: 830px) {
    .menu {
      .link {
        font-size: 1rem;
      }
    }
    .btn {
      width: 80px;
      font-size: 1.2rem;
      padding: 1px 5px;
    }
  }

  @media screen and (max-width: 790px) {
    .menu {
      .link {
        font-size: 0.908rem;
      }
    }
  }

  @media screen and (max-width: 730px) {
    .menu {
      display: none;
    }
    .sair-instagram{
      display: none;
  }
    .btn {
      display: none;
    }
    .imag {
      width: 100VW;
      justify-content: space-between;

  }

    .menu-hamburguer {
      display: block;
      z-index: 4;
      &:hover {
        background-color: #b8384a;
      }
    }
  }
`;
